<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--provision"></div>
      <div class="modal__close" @click="closeModal()"></div>
      <div class="form">
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <div class="add__content">
              <div class="modal__provision">
                <div class="modal__provision-title">{{ $t(`policyProvision.${"title"}`) }}</div>
                <div class="modal__provision-container">
                  <div class="modal__provision-row">
                    <div class="form__field form__field--margin">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"customer"}`) }}:</div>
                      <div class="modal__provision-data">
                        {{ parseCustomerName(customer) || statics.empty }}
                      </div>
                    </div>
                    <div class="form__field">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"company"}`) }}:</div>
                      <div class="modal__provision-data">
                        {{ serviceData?.company?.full_name || statics.empty }}
                      </div>
                    </div>
                    <div class="form__field form__field--margin">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"service"}`) }}:</div>
                      <div class="modal__provision-data">
                        {{
                          selectedPolicyService.service?.[`long_${language}`] ||
                          statics.empty
                        }}
                      </div>
                    </div>
                    <div class="form__field">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"policyNr"}`) }}:</div>
                      <div class="modal__provision-data">
                        {{ serviceData?.policy_number || statics.empty }}
                      </div>
                    </div>
                    <div class="form__field form__field--margin">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"agent"}`) }}:</div>
                      <div class="modal__provision-data">
                        {{
                          `${serviceData?.agent?.first_name || statics.empty} ${serviceData?.agent?.last_name ||
                          statics.empty}`
                        }}
                      </div>
                    </div>
                    <div class="form__field">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"date"}`) }}:</div>
                      <div class="modal__provision-data">
                        {{ `${startDate} - ${endDate}` }}
                      </div>
                    </div>

                    <div v-if="serviceData?.second_agent" class="form__field form__field--margin">
                      <div class="modal__provision-label">{{ $t(`addSaleCategoryModal.${"secondAgent"}`) }}:</div>
                      <div class="modal__provision-data">
                        {{ serviceData?.second_agent?.first_name }} {{ serviceData?.second_agent?.last_name }}
                      </div>
                    </div>

                    <div class="form__field " :class="{ 'form__field--margin': !serviceData?.second_agent }">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"supervisor"}`) }}:</div>

                      <div v-if="serviceData?.agent?.supervisors && serviceData?.agent?.supervisors.length > 0"
                        style="width: 90%;">
                        <p>
                          {{ serviceData?.agent?.supervisors?.[0]?.first_name }}
                          {{ serviceData?.agent?.supervisors?.[0]?.last_name }}
                        </p>
                      </div>
                      <div v-else>
                        <p class="empty">----------</p>
                      </div>
                    </div>

                    <div class="form__field  ">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"salesCategory"}`) }}:</div>
                      <div class="modal__provision-data" v-if="serviceData?.agent?.sales_category">
                        {{ serviceData?.agent?.sales_category?.name }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal__provision-container modal__provision-statuses" v-if="paymentsList.length > 0">

                  <Loading v-if="editingRow" class="row-loading" />
                  <div v-else class="modal__provision-row" style="margin-bottom: 20px"
                    v-for="(servicePayment, index) in paymentsList" :key="servicePayment.id">
                    <div class="provision-wrapper">
                      <div class="form__field form__field--margin  form__field-vertical" style="margin-bottom: 0;">

                        <div class="modal__provision-label">
                          {{ $t(`policyProvision.${"receivedOn"}`) }}:
                        </div>

                        <span
                          v-if="serviceData?.agent?.sales_category && $checkRolePermission('policy_service_payment_edit') && !servicePayment.paid"
                          class="editable" @click="handleDateEdit(servicePayment, index)">

                          <PopupEditer :isDate="true" v-if="policyPaymentEditors[index]?.showPendingDateEditor"
                            @togglePopup="setEditorVisibility(index, 'showPendingDateEditor', $event)"
                            :selected="servicePayment.pending_date"
                            @submit="openPendingDateSubmitter($event, servicePayment.id, index)" />

                          {{ `${formatDate(servicePayment.pending_date)}` }}
                        </span>

                        <span v-else>
                          {{ `${formatDate(servicePayment.pending_date)}` }}
                        </span>

                      </div>

                      <div class="form__field form__field--margin  form__field-vertical" style="margin-bottom: 0;">

                        <div class="modal__provision-label ">{{ $t(`policyProvision.${"provision"}`) }}:</div>

                        <div v-if="serviceData?.agent?.sales_category">
                          <span v-if="!servicePayment.paid && $checkRolePermission('policy_service_payment_edit')"
                            class="editable" @click="handleEdit(servicePayment, index)">
                            <PopupEditer :isPrice="true" :allowNegative="true"
                              v-if="policyPaymentEditors[index]?.showTotalEditor"
                              @togglePopup="setEditorVisibility(index, 'showTotalEditor', $event)"
                              :selected="servicePayment.total"
                              @submit="openSubmitter($event, servicePayment.id, index)" />
                            {{ servicePayment.total }} .- CHF
                          </span>

                          <span v-else>
                            {{ servicePayment.total }} .- CHF
                          </span>
                        </div>

                        <span v-else>
                          {{ $t(`policyProvision.${"agentNoSaleCategory"}`) }}
                        </span>
                      </div>

                    </div>
                    <div class="payment-status-wrapper">
                      <div :class="`payment-status
                          ${checkServicePaymentPaidStatus(servicePayment) ? (servicePayment.is_return ? 'payment-status-canceled' : 'payment-status-paid') : 'payment-status-pending'}`
                        ">

                        <div v-if="checkServicePaymentPaidStatus(servicePayment)">
                          <div
                            :class="`icon ${servicePayment.is_return ? 'icon__payment--canceled' : 'icon__payment--paid'}`">
                          </div>
                        </div>
                        <div v-else>
                          <div class="icon icon__payment--pending"></div>
                        </div>

                        <div>
                          <p>
                            {{ checkServicePaymentPaidStatus(servicePayment) ? (servicePayment.is_return ?
                              $t(`policyProvision.${"canceled"}`) : $t(`policyProvision.${"paid"}`)) :
                              $t(`policyProvision.${"pending"}`) }}
                          </p>

                          <p class="created-at">
                            {{ servicePayment.paid_date ? `${formatDate(servicePayment.paid_date)}` :
                              formatDate(servicePayment.created_at) }}
                          </p>
                        </div>
                      </div>

                      <div
                        v-if="!showAddNewPolicyPayment && !servicePayment.paid && $checkRolePermission('policy_service_payment_create')"
                        class="payment-status payment-status-make-payment"
                        @click="confirmPayment = true; otherPaymentId = servicePayment.id">
                        <p style="color: white;">{{ $t(`policyProvision.${"makePayment"}`) }}</p>
                      </div>

                      <div v-if="
                        $checkRolePermission('policy_service_payment_create') &&
                        showAddNewPolicyPayment &&
                        additionalPayments.length === 0 &&
                        paymentsList.every(payment => payment.paid === 1) &&
                        index === 0
                      " class="payment-status payment-status-add">
                        <div class="payment-status-add-img" @click="addNewPayment(selectedPolicyService.id)">
                          <img src="@/assets/icons/default/add_icon.svg">
                        </div>
                      </div>

                      <div v-if="$checkRolePermission('policy_service_payment_delete')"
                        class="payment-status-delete-img" @click="openDeletePayment(servicePayment.id)">
                        <img src="@/assets/icons/default/delete_icon.svg">
                      </div>
                    </div>
                  </div>
                </div>


                <div v-if="showProvisionContainer" class="modal__provision-container">

                  <div class="modal__provision-row" v-for="(additionalPayment, idx) in additionalPayments" :key="idx">

                    <div class="form__field form__field--margin">
                      <div class="modal__provision-label">{{ $t(`policyProvision.${"provision"}`) }}: </div>
                      <span v-if="$checkRolePermission('policy_service_payment_edit')" class="editable"
                        @click="showTotalEditer2 = true">
                        <PopupEditer :isPrice="true" :allowNegative="true" v-if="showTotalEditer2"
                          @togglePopup="showTotalEditer2 = $event" :selected="additionalPayment.total"
                          @submit="openSubmitter2($event)" />
                        {{ additionalPayment.total }} .- CHF
                      </span>

                      <span v-else>{{ additionalPayment.total }} .- CHF</span>
                    </div>
                    <div class="payment-status-wrapper">
                      <div :class="`payment-status payment-status-unpaid `">
                        <div :class="`icon icon__payment`"></div>
                        <p>{{ $t(`policyProvision.${"unpaid"}`) }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isRequesting"
                class="button modal__button modal__button--submit button--default button--loading"></div>
              <button v-if="
                showButton &&
                !isRequesting &&
                ($checkRolePermission('policy_service_payment_create') || $checkRolePermission('policy_service_payment_edit'))
              " @click="updateTotal" class="button modal__button modal__button--submit button--default">
                {{ $t(`buttons.${"saveBtn"}`) }}
              </button>
            </div>
          </transition>
        </div>
      </div>


      <div class="modal__submit" v-if="showSubmitter">
        <div class="modal__submit-panel">
          <div class="modal__submit-icon"></div>
          <div class="modal__submit-border"></div>
          <div class="modal__submit-container">
            <div class="modal__submit-text">
              {{ $t(`policyProvision.${"provisionChanges"}`) }}?
            </div>
            <div class="modal__submit-buttons loading-state" v-if="isRefreshingCustomer">
              <div class="button button--default button--loading"></div>
            </div>
            <div v-else class="modal__submit-buttons">
              <button class="modal__submit-button" @click="applyTotal(paymentIdToEdit)">
                {{ $t(`buttons.${"yesBtn"}`) }}
              </button>
              <button class="modal__submit-button" @click="closeSubmitter()">
                {{ $t(`buttons.${"cancelBtn"}`) }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal__submit" v-if="confirmPayment">
        <div class="modal__submit-panel">
          <div class="modal__submit-icon"></div>
          <div class="modal__submit-border"></div>
          <div class="modal__submit-container">
            <div class="modal__submit-text">
              {{ $t(`policyProvision.${"confirmPayment"}`) }}?
            </div>
            <div class="modal__submit-buttons loading-state" v-if="isRefreshingCustomer">
              <div class="button button--default button--loading"></div>
            </div>
            <div v-else class="modal__submit-buttons">
              <button class="modal__submit-button" @click="updateStatus(otherPaymentId)">
                {{ $t(`buttons.${"yesBtn"}`) }}
              </button>
              <button class="modal__submit-button" @click="confirmPayment = false">
                {{ $t(`buttons.${"cancelBtn"}`) }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal__submit" v-if="showDeleteProvisionModal">
        <div class="modal__submit-panel">
          <div class="modal__submit-icon"></div>
          <div class="modal__submit-border"></div>
          <div class="modal__submit-container">
            <div class="modal__submit-text">
              {{ $t(`policyProvision.${"deletePayment"}`) }}?
            </div>
            <div class="modal__submit-buttons loading-state" v-if="isRefreshingCustomer">
              <div class="button button--default button--loading"></div>
            </div>
            <div v-else class="modal__submit-buttons">
              <button class="modal__submit-button" @click="deletePayment()">
                {{ $t(`buttons.${"yesBtn"}`) }}
              </button>
              <button class="modal__submit-button" @click="closeDeleteProvisionModal()">
                {{ $t(`buttons.${"cancelBtn"}`) }}
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import PopupEditer from "@/partials/PopupEditer";
import { parseCustomerName } from "@/helpers/entityParsers";
import { fetchGlobalCustomer } from "@/helpers/accountDetailHelpers";
import statics from "@/statics";
import { useI18n } from 'vue-i18n';


import Loading from "@/partials/Loading";

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();
defineOptions({
  name: "PolicyProvisionModal"
});

const store = useStore();

const { proxy } = getCurrentInstance();

// Reactive Local Properties
const showDeleteProvisionModal = ref(false);
const paymentToDeleteId = ref(null);

const editingRow = ref(false);
const showButton = ref(false);
const showTotalEditer2 = ref(false);
const paid = ref(0);
const preTotal = ref(0);
const total = ref(0);
const previousPrice = ref(0);
const showSubmitter = ref(false);
const showPendingDateSubmitter = ref(false);
const isRequesting = ref(false);
const isRefreshingCustomer = ref(false);

const confirmPayment = ref(false);
const additionalPayments = ref([]);
const showAddNewPolicyPayment = ref(false);
const policyPaymentEditors = ref([]);
const otherPaymentId = ref("");

const pendingDateToEditId = ref(null);
const paymentIdToEdit = ref(null);
const paymentValToEdit = ref(null);

const paymentsList = ref([]);

// Computed Mappings
const selectedPolicyService = computed(() => store.getters.selectedPolicyService);
const customer = computed(() => store.getters.customer);
const language = computed(() => store.getters.language);

const serviceData = computed(() => {
  if (customer.value?.policies?.length) {
    return customer.value.policies.find(
      (policy) => policy.id === selectedPolicyService.value?.policy_id
    );
  }
  return null;
});

const startDate = computed(() => {
  if (selectedPolicyService.value?.start_date) {
    const date = new Date(selectedPolicyService.value.start_date.split("T")[0]);
    return date.toLocaleDateString('de-CH');
  }
  return statics.empty;
});

const endDate = computed(() => {
  if (selectedPolicyService.value?.end_date) {
    const date = new Date(selectedPolicyService.value.end_date.split("T")[0]);
    return date.toLocaleDateString('de-CH');
  }
  return statics.empty;
});

const showProvisionContainer = computed(() => {
  return additionalPayments.value.length > 0 || paymentsList.value.length === 0;
});

// Watchers
watch(total, (newTotal) => {
  if (newTotal !== previousPrice.value) {
    showButton.value = true;
  } else {
    showButton.value = false;
  }
});

watch(additionalPayments, (newVal) => {
  if (newVal.length > 0) {
    const additionalTotal = newVal[0].total;
    if (additionalTotal !== previousPrice.value) {
      showButton.value = true;
    } else {
      showButton.value = false;
    }
  }
}, { deep: true });

// Methods
const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};

const closeModal = () => {
  store.commit("setShowPolicyProvisionModal", false);
};

const refreshCustomerData = async () => {
  if (customer.value?.id) {
    try {
      await fetchGlobalCustomer(customer.value.id);
    } finally {
      isRefreshingCustomer.value = false;
    }
  }
};

const openDeletePayment = (id) => {
  showDeleteProvisionModal.value = true;
  paymentToDeleteId.value = id;
};

const deletePayment = async () => {
  isRefreshingCustomer.value = true;

  try {
    const policyServiceId = paymentToDeleteId.value;
    const result = await store.dispatch("deletePolicyServicePayment", policyServiceId);

    if (result.success) {
      await refreshCustomerData();
      store.commit("setToast", {
        display: true,
        type: "success",
        message: t("messages.paymentDeletedSuccessfully"),
      });
    } else {
      store.commit("setToast", {
        display: true,
        type: "error",
        message: result.message,
      });
    }
  } catch (err) {
    store.commit("setToast", {
      display: true,
      type: "error",
      message: err.message || "An unexpected error occurred",
    });
  } finally {
    updateShowAddNewPolicyPayment();
    isRefreshingCustomer.value = false;
    showDeleteProvisionModal.value = false;
  }
};

const closeDeleteProvisionModal = () => {
  showDeleteProvisionModal.value = false;
  paymentToDeleteId.value = null;
};

const initializePolicyPayments = async () => {
  const data = await store.dispatch(
    "fetchPolicyServicePayments",
    selectedPolicyService.value.id
  );

  paymentsList.value = data.data;

  if (paymentsList.value.length > 0) {
    policyPaymentEditors.value = paymentsList.value.map((payment) => ({
      paymentId: payment.id,
      showTotalEditor: false,
      showPendingDateEditor: false,
    }));
    const allPaid = paymentsList.value.every(payment => payment.paid == true);
    showAddNewPolicyPayment.value = allPaid;
  } else {
    addPolicyServicePayment(selectedPolicyService.value.id);
  }
};

const updateShowAddNewPolicyPayment = () => {
  additionalPayments.value = [];
  showAddNewPolicyPayment.value = false;
  policyPaymentEditors.value = [];
  otherPaymentId.value = '';

  isRequesting.value = false;
  showButton.value = false;

  paymentIdToEdit.value = null;
  paymentValToEdit.value = null;

  initializePolicyPayments();
};

const checkServicePaymentPaidStatus = (servicePayment) => {
  return servicePayment.paid == 1;
};

const ensureEditorState = (servicePayment, index) => {
  if (!policyPaymentEditors.value[index]) {
    policyPaymentEditors.value[index] = {
      paymentId: servicePayment.id,
      showTotalEditor: false,
      showPendingDateEditor: false,
    };
  } else if (policyPaymentEditors.value[index].paymentId !== servicePayment.id) {
    policyPaymentEditors.value[index].paymentId = servicePayment.id;
  }

  return policyPaymentEditors.value[index];
};

const setEditorVisibility = (index, field, value) => {
  if (!policyPaymentEditors.value[index]) {
    policyPaymentEditors.value[index] = {
      paymentId: paymentsList.value[index]?.id,
      showTotalEditor: false,
      showPendingDateEditor: false,
    };
  }

  policyPaymentEditors.value[index][field] = value;
};

const handleEdit = (servicePayment, index) => {
  if (servicePayment.paid == 1) {
    return;
  }
  closeAllEditors();
  const editor = ensureEditorState(servicePayment, index);
  editor.showTotalEditor = true;
};

const handleDateEdit = (servicePayment, index) => {
  closeAllEditors();
  const editor = ensureEditorState(servicePayment, index);
  editor.showPendingDateEditor = true;
};

const closeAllEditors = () => {
  policyPaymentEditors.value.forEach(editor => {
    if (editor) {
      editor.showTotalEditor = false;
      editor.showPendingDateEditor = false;
    }
  });
};

const addPolicyServicePayment = (id) => {
  additionalPayments.value.push({ policy_service_id: id, total: 0 });
};

const openSubmitter = (total, id) => {
  showSubmitter.value = true;
  preTotal.value = total;
  paymentIdToEdit.value = id;
  paymentValToEdit.value = total;
};

const openPendingDateSubmitter = async (date, id, index) => {
  editingRow.value = true;
  showPendingDateSubmitter.value = true;

  try {
    const response = await store.dispatch("changePolicyServicePendingDate", {
      policyServicePaymentId: id,
      pendingDate: date,
    });

    const updatedPayment = response?.data?.data;

    if (updatedPayment) {
      paymentsList.value = paymentsList.value.map((payment) =>
        payment.id === updatedPayment.id ? updatedPayment : payment
      );

      if (selectedPolicyService.value?.policy_service_payments?.length) {
        store.commit("setSelectedPolicyService", {
          ...selectedPolicyService.value,
          policy_service_payments: selectedPolicyService.value.policy_service_payments.map((payment) =>
            payment.id === updatedPayment.id ? updatedPayment : payment
          ),
        });
      }

      setEditorVisibility(index, "showPendingDateEditor", false);
      pendingDateToEditId.value = id;
    }
  } catch (err) {
    console.error(err);
    store.commit("setToast", {
      display: true,
      type: "error",
      message: err.response?.data?.message || err.message || "An unexpected error occurred",
    });
  } finally {
    showPendingDateSubmitter.value = false;
    editingRow.value = false;
  }
};

const openSubmitter2 = (total) => {
  additionalPayments.value[0].total = total;
  paymentValToEdit.value = total;
};

const applyTotal = async (id) => {
  isRefreshingCustomer.value = true;

  try {
    if (additionalPayments.value.length > 0) {
      additionalPayments.value[0].total = preTotal.value;
    } else {
      if (selectedPolicyService.value?.policy_service_payments?.length > 0) {
        const payment = selectedPolicyService.value.policy_service_payments.find(payment => payment.id == id);
        if (payment) {
          payment.total = preTotal.value;
          showButton.value = true;
        }
      }
    }

    showSubmitter.value = false;
    await updateTotal();
  } finally {
    isRefreshingCustomer.value = false;
  }
};

const closeSubmitter = () => {
  preTotal.value = 0;
  paymentIdToEdit.value = '';
  showSubmitter.value = false;
};

const addNewPayment = (id) => {
  addPolicyServicePayment(id);
  paymentIdToEdit.value = null;
  paymentValToEdit.value = null;
};

const updateTotal = async () => {
  isRequesting.value = true;
  editingRow.value = true;

  try {
    const policyServiceId = paymentIdToEdit.value ? paymentIdToEdit.value : selectedPolicyService.value.id;
    const totalVal = Number(paymentValToEdit.value);
    const state = paymentIdToEdit.value ? 'update' : 'create';

    const {
      data: { data },
    } = await store.dispatch("changePolicyServicePaymentPrice", {
      policyServiceId,
      total: totalVal,
      state,
    });

    const paymentResponse = Array.isArray(data) ? data : [data];
    const updatedPayment = paymentResponse[0];

    paymentValToEdit.value = updatedPayment?.total;
    previousPrice.value = paymentValToEdit.value;

    if (state == "update") {
      const nextPayments = paymentsList.value.map((payment) =>
        payment.id === updatedPayment?.id ? updatedPayment : payment
      );

      paymentsList.value = nextPayments;
      store.commit("setSelectedPolicyService", {
        ...selectedPolicyService.value,
        policy_service_payments: nextPayments,
      });
    } else {
      paymentsList.value = [...paymentsList.value, ...paymentResponse];
      store.commit("setSelectedPolicyService", {
        ...selectedPolicyService.value,
        policy_service_payments: [...paymentsList.value],
      });
    }

    const payments = await store.dispatch(
      "fetchPolicyServicePayments",
      selectedPolicyService.value.id
    );

    paymentsList.value = payments.data;
    await refreshCustomerData();
  } catch (err) {
    console.error(err);
    store.commit("setToast", {
      display: true,
      type: "error",
      message: err.response?.data?.message || err.message || "An unexpected error occurred",
    });
  } finally {
    updateShowAddNewPolicyPayment();
    editingRow.value = false;
  }
};

const updateStatus = async (id) => {
  isRequesting.value = true;
  isRefreshingCustomer.value = true;

  try {
    const {
      data: { data },
    } = await store.dispatch("changePolicyServicePaidState", {
      policyServiceId: id,
      paid: true,
    });

    paid.value = data.paid;

    store.commit("setSelectedPolicyService", {
      ...selectedPolicyService.value,
      policy_service_payments: selectedPolicyService.value.policy_service_payments.map(payment =>
        payment.id === data.id ? data : payment
      ),
    });

    const payments = await store.dispatch(
      "fetchPolicyServicePayments",
      selectedPolicyService.value.id
    );

    paymentsList.value = payments.data;
    await refreshCustomerData();
    confirmPayment.value = false;
  } catch (err) {
    console.error(err);
  } finally {
    isRefreshingCustomer.value = false;
    isRequesting.value = false;
    updateShowAddNewPolicyPayment();
  }
};

// Lifecycle
onMounted(async () => {
  if (!proxy.$checkRolePermission('policy_service_payment_access')) {
    closeModal();
  } else {
    initializePolicyPayments();
  }
});
</script>

<style scoped lang="scss">
.pending__date__wrapper {
  margin-left: 10px;
  padding-left: 10px;
  border-left: #9b9b9b 1px solid;
}

.payment-status-name {

  text-align: center;
}

.provision-wrapper {
  width: 50%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;

  .form__field {
    display: flex;
  }
}

.created-at {
  color: #7F8FA4;
  font-size: 12px;
  margin-top: 5px;
}

.payment-status {
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  height: 48px;
  width: 43%;
  transition: 0.3s ease;

  &-wrapper {
    display: flex;
    gap: 2.3%;
    justify-content: space-between;
    width: calc(50% - 10px);
  }

  &-unpaid {
    background-color: #7f8fa433;
  }

  &-pending {
    background-color: rgba(255, 159, 15, 0.2)
  }

  &-paid {
    background-color: rgba(30, 189, 123, 0.2);
  }

  &-canceled {
    background-color: #FFD1D1;
  }

  &-make-payment {
    background-color: var(--bg-2);
    color: var(--text-1);
    cursor: pointer;
  }

  &-make-payment:hover {
    background-color: var(--hover-1);
  }

  p {
    color: var(--text-9);
    font-family: var(--muli-text-semi-bold);
    text-align: center;
  }

  &-add {
    gap: 30px;
  }

  &-add-img {
    background-color: var(--bg-2);
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: 0.3s ease;
  }

  &-add-img:hover {
    background-color: var(--hover-1);
  }

  &-add-img img {
    width: 13px;
    height: 13px;
  }

  &-delete-img {
    width: 7%;
    align-items: center;
    height: 48px;
    display: flex;
  }

  &-delete-img img {
    cursor: pointer;
    max-width: 24px;
  }
}


.created-at {
  color: #7F8FA4 !important;
  text-align: left !important;
}

[data-theme="dark"] .created-at {
  color: white !important;
}

[data-theme="dark"] .payment-status-canceled {
  background-color: #B45F5F;

}

.add {
  &__form {
    width: 100% !important;
    height: initial !important;
  }
}

.modal {
  &__panel {
    height: auto !important;
  }

  &__provision,
  & {
    padding: 28px 0;

    &-title {
      font-size: var(--medium);
    }

    &-title,
    &-label {
      color: var(--text-2);
    }

    &-label {
      margin-right: 10px;

    }



    &-data {
      color: var(--text-9);
      font-family: var(--muli-text-semi-bold);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 335px;
      display: flex;
    }

    &-container {
      margin-top: 25px;
      padding-top: 15px;
      border-top: 1px solid var(--border-10);

    }

    &-statuses {
      max-height: 170px;
      overflow: visible;
      overflow-y: scroll;
    }

    &-row {
      display: flex;
      flex-wrap: wrap;
      padding: 0 50px;

      .form__field {
        width: calc(50% - 10px);
        background: var(--bg-23);
        padding: 15px;
        border-radius: var(--radius-1);
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        height: 48px;

        &--margin {
          margin-right: 20px;
        }

        &--status {
          cursor: pointer;
        }

        &--paid {
          background: var(--bg-25);
          border: 1px solid var(--border-2);

          .modal__provision-data {
            color: var(--text-5);
          }
        }

        &--unpaid {
          background: var(--bg-24);

          .modal__provision-data {
            color: var(--text-12);
          }
        }

        &--supervisors {
          width: 100%;
        }

        &--empty {
          background: 0;
        }

        &-vertical {
          flex-direction: column;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: center;
          padding: 5px;
          height: 48px;

          .modal__provision-label {
            margin-right: 0px;
          }
        }
      }

      .button {
        background-color: var(--bg-2);
        justify-content: center;
        font-family: var(--muli-text-regular);

        &:hover {
          background-color: var(--hover-1);
        }
      }
    }

    &-arrow {
      background: url("../assets/icons/default/next_arrow.svg");
      height: 16px;
      width: 16px;
      margin: 0 10px;
    }
  }

  &__submit {
    position: absolute;
    height: 100%;
    width: 100%;
    background: var(--modal-bg-2);
    backdrop-filter: blur(10px);
    top: 0;
    left: 0;
    border-radius: inherit;
    display: flex;
    align-items: center;
    justify-content: center;

    &-panel {
      width: 370px;
      padding: 9px 15px;
      background: var(--text-5);
      border-radius: var(--radius-1);
      display: flex;
      align-items: center;
    }

    &-icon {
      background: url("../assets/icons/default/question_icon.svg");
      min-width: 30px;
      height: 30px;
    }

    &-border {
      width: 1px;
      height: 70px;
      margin: 0 15px;
      background: var(--border-16);
    }

    &-container {
      flex-direction: column;
      align-items: flex-start;
    }

    &-buttons,
    &-container {
      display: flex;
      justify-content: center;
    }

    &-button {
      border-radius: var(--radius-1);
      box-shadow: 0px 3px 6px var(--shadow-3);
      color: var(--text-2);
      padding: 5px 0 5px 0;
      width: 100px;
      transition: all 0.3s ease;

      &:hover {
        color: var(--text-5);
        box-shadow: none;
      }

      &:first-child {
        margin-right: 50px;
      }
    }

    &-text {
      color: var(--text-1);
      margin-bottom: 15px;
    }
  }
}

[data-theme="dark"] .modal__submit-button {
  background-color: #313B47 !important;
}

.loading-state {
  width: 100%;

  .button--loading {
    width: 150px;
    border: 1px solid white;
  }
}

.modal__provision-data {
  overflow-x: auto;
}

.row-loading {
  position: relative !important;
  height: 60px !important;
  overflow: hidden !important;
}

.provision-wrapper span,
.form__field .empty {
  color: var(--text-9);
}

.provision-wrapper .editable {
  color: var(--text-10);
}
</style>
